import { useEditTopicTypeList, useReadFaq, useReadTopicType, } from "../../hooks";
import { useUser } from "../../../../../util/userContext/UserContext";
import { useEffect } from "react";
import AuthorityChecker from "../../../../../components/common/authorityGuard/AuthorityChecker";

export const SearchFilter = () => {
    const { searchParam, setSearchParam, search, addRemoveTopicType } =
        useReadFaq();
    const { data: topicTypeData } = useReadTopicType();
    const { editArr, onEdit, addTopicType, updateTopicType, deleteTopicType } =
        useEditTopicTypeList();
    const { user } = useUser();

    const editOrViewBox = (item: any) => {
        const found = editArr.find((editItem) => editItem.idx === item.idx);

        if (found) {
            return (
                <input
                    autoFocus={true}
                    type="text"
                    className="form-control p-0"
                    value={found.codeEntriesName}
                    onLoad={(e) => e.currentTarget.focus()}
                    onClick={(e) => e.stopPropagation()}
                    onChange={(e) => onEdit(item.idx, e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter")
                            updateTopicType(found.idx, found.codeEntriesName);
                    }}
                />
            );
        } else {
            return <label>{item.codeEntriesName}</label>;
        }
    };

    useEffect(() => {
        search();
    }, [searchParam.topicTypeList]);

    const topicTypeListBox = (item: any) => {
        return (
            <div
                className={`tag_inputbox ${editArr.find((editItem) => editItem.idx === item.idx) ? 'active' :
                    searchParam.topicTypeList.includes(item.codeEntriesName) ? "blue" : ""}`}
                key={item.idx}
                onClick={() => {
                    addRemoveTopicType(item.codeEntriesName)
                }}
            >
                {editOrViewBox(item)}
                <AuthorityChecker authorityNames={['faqWriteYn']}>
                    <div className="tag_toolbar">
                        <button
                            className="btn btn-link p-0"
                            onClick={(e) => {
                                e.stopPropagation();
                                updateTopicType(item.idx, item.codeEntriesName);
                            }}
                        >
                            <img
                                src={
                                    process.env.PUBLIC_URL + "/assets/images/icon_edittoken.png"
                                }
                                alt=""
                            />
                        </button>
                        <button
                            className="btn btn-link p-0"
                            onClick={(e) => {
                                e.stopPropagation();
                                deleteTopicType(item.idx);
                            }}
                        >
                            <img
                                src={
                                    process.env.PUBLIC_URL + "/assets/images/icon_deltoken.png"
                                }
                                alt=""
                            />
                        </button>
                    </div>
                </AuthorityChecker>
            </div>
        );
    };

    return (
        <div className="fiter_wrap">
            <div className="fiter_top">
                <h3 className="filter_heading">자주 묻는 질문 검색</h3>
                <div className="filter_toolbar"></div>
            </div>
            <div className="row">
                <div className="col-6">
                    <div className="frm_row justify-content-start">
                        <label htmlFor="" className="form-label frm_label">
                            유형
                        </label>
                        <div className="frm_row justify-content-start align-items-center">
                            <div className="tag_outer">
                                {(topicTypeData ?? []).map((item: any) =>
                                    topicTypeListBox(item)
                                )}
                                {editArr
                                    .filter((item) => item.idx <= 0)
                                    .map((item) => topicTypeListBox(item))}
                                <AuthorityChecker authorityNames={['faqWriteYn']}>
                                    <button
                                        className="btn btn-info p-0 w-30px h-30px"
                                        onClick={() => addTopicType(0, "")}
                                    >
                                        <img
                                            className="m-0"
                                            src={
                                                process.env.PUBLIC_URL + "/assets/images/icon_plus.png"
                                            }
                                            alt=""
                                        />
                                    </button>
                                </AuthorityChecker>
                            </div>
                        </div>
                    </div>
                    <div className="frm_row search justify-content-start">
                        <label htmlFor="" className="form-label frm_label">
                            옵션
                        </label>
                        <select
                            className="form-select"
                            value={searchParam.keywordType}
                            onChange={(e) =>
                                setSearchParam((prev) => ({
                                    ...prev,
                                    keywordType: parseInt(e.target.value),
                                }))
                            }
                        >
                            <option value="1">전체</option>
                            <option value="2">제품</option>
                            <option value="3">카테고리</option>
                            <option value="4">제목</option>
                        </select>
                        <input
                            type="text"
                            className="form-control me-0"
                            placeholder="검색어를 입력해주세요"
                            value={searchParam.keyword}
                            onChange={(e) =>
                                setSearchParam((prev) => ({ ...prev, keyword: e.target.value }))
                            }
                            onKeyDown={(e) => {
                                if (e.key === "Enter") search();
                            }}
                        />
                        <button
                            className="btn btn-info btn_search"
                            onClick={() => search()}
                        >
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                                alt=""
                            />
                            조회
                        </button>
                    </div>
                </div>
                <div className="col-6"></div>
            </div>
        </div>
    );
};
